/**
 * "12m ago" / "3h ago" / "just now" for a run's start time. Shared by
 * `LiveRunCard` (the "started Xm ago" line) and `LiveRunTabs` (the
 * disambiguating suffix on a hover-expanded tab) — both live in this same
 * `test-runs/` feature folder and want the exact same wording, so this stays
 * a local helper rather than a `packages/ui`/shared-lib utility. The rest of
 * the app has several independent "relative ago" implementations already
 * (see `apps/web/src/features/sandboxes/components/overview/time-format.ts`'s
 * own comment on this) — this is one more scoped to its own small surface,
 * not an attempt to consolidate them.
 *
 * @module ui/pages/runs/test-runs/relativeStartTime
 */
export function formatRelativeStartTime(startedAt: string | null): string {
  if (!startedAt) return '';
  const deltaMs = Date.now() - new Date(startedAt).getTime();
  if (!Number.isFinite(deltaMs) || deltaMs < 0) return 'just now';
  const minutes = Math.floor(deltaMs / 60_000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
}
